import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/x-icon.png'
import _imports_1 from '../../assets/remove-icon.svg'
import _imports_2 from '../../assets/add-icon.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", { class: "len-title" }, "Service Type:", -1)
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "close"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "remove-icon"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", null, "Delete", -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "add-icon"
}, null, -1)
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "close"
}, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "remove-icon"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("button", null, "Delete", -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "add-icon"
}, null, -1)
const _hoisted_18 = {
  key: 0,
  class: "ml-4"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h3", null, "Check only one", -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "close"
}, null, -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "remove-icon"
}, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("button", null, "Delete", -1)
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "add-icon"
}, null, -1)
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "close"
}, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "remove-icon"
}, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("button", null, "Delete", -1)
const _hoisted_35 = [
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "add-icon"
}, null, -1)
const _hoisted_37 = ["onClick"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "close"
}, null, -1)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "remove-icon"
}, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("button", null, "Delete", -1)
const _hoisted_43 = [
  _hoisted_41,
  _hoisted_42
]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "add-icon"
}, null, -1)
const _hoisted_45 = ["onClick"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "close"
}, null, -1)
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = ["onClick"]
const _hoisted_49 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "remove-icon"
}, null, -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("button", null, "Delete", -1)
const _hoisted_51 = [
  _hoisted_49,
  _hoisted_50
]
const _hoisted_52 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "add-icon"
}, null, -1)
const _hoisted_53 = ["onClick"]
const _hoisted_54 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "close"
}, null, -1)
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = ["onClick"]
const _hoisted_57 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "remove-icon"
}, null, -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("button", null, "Delete", -1)
const _hoisted_59 = [
  _hoisted_57,
  _hoisted_58
]
const _hoisted_60 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "add-icon"
}, null, -1)
const _hoisted_61 = ["onClick"]
const _hoisted_62 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "close"
}, null, -1)
const _hoisted_63 = [
  _hoisted_62
]
const _hoisted_64 = ["onClick"]
const _hoisted_65 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "remove-icon"
}, null, -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("button", null, "Delete", -1)
const _hoisted_67 = [
  _hoisted_65,
  _hoisted_66
]
const _hoisted_68 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "add-icon"
}, null, -1)
const _hoisted_69 = ["onClick"]
const _hoisted_70 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "close"
}, null, -1)
const _hoisted_71 = [
  _hoisted_70
]
const _hoisted_72 = ["onClick"]
const _hoisted_73 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "remove-icon"
}, null, -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("button", null, "Delete", -1)
const _hoisted_75 = [
  _hoisted_73,
  _hoisted_74
]
const _hoisted_76 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "add-icon"
}, null, -1)
const _hoisted_77 = ["onClick"]
const _hoisted_78 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "close"
}, null, -1)
const _hoisted_79 = [
  _hoisted_78
]
const _hoisted_80 = ["onClick"]
const _hoisted_81 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "remove-icon"
}, null, -1)
const _hoisted_82 = /*#__PURE__*/_createElementVNode("button", null, "Delete", -1)
const _hoisted_83 = [
  _hoisted_81,
  _hoisted_82
]
const _hoisted_84 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "add-icon"
}, null, -1)
const _hoisted_85 = ["onClick"]
const _hoisted_86 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "close"
}, null, -1)
const _hoisted_87 = [
  _hoisted_86
]
const _hoisted_88 = ["onClick"]
const _hoisted_89 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "remove-icon"
}, null, -1)
const _hoisted_90 = /*#__PURE__*/_createElementVNode("button", null, "Delete", -1)
const _hoisted_91 = [
  _hoisted_89,
  _hoisted_90
]
const _hoisted_92 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "add-icon"
}, null, -1)
const _hoisted_93 = ["onClick"]
const _hoisted_94 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "close"
}, null, -1)
const _hoisted_95 = [
  _hoisted_94
]
const _hoisted_96 = ["onClick"]
const _hoisted_97 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "remove-icon"
}, null, -1)
const _hoisted_98 = /*#__PURE__*/_createElementVNode("button", null, "Delete", -1)
const _hoisted_99 = [
  _hoisted_97,
  _hoisted_98
]
const _hoisted_100 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "add-icon"
}, null, -1)
const _hoisted_101 = ["onClick"]
const _hoisted_102 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "close"
}, null, -1)
const _hoisted_103 = [
  _hoisted_102
]
const _hoisted_104 = ["onClick"]
const _hoisted_105 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "remove-icon"
}, null, -1)
const _hoisted_106 = /*#__PURE__*/_createElementVNode("button", null, "Delete", -1)
const _hoisted_107 = [
  _hoisted_105,
  _hoisted_106
]
const _hoisted_108 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "add-icon"
}, null, -1)
const _hoisted_109 = ["onClick"]
const _hoisted_110 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "remove-icon"
}, null, -1)
const _hoisted_111 = /*#__PURE__*/_createElementVNode("button", null, "Delete", -1)
const _hoisted_112 = [
  _hoisted_110,
  _hoisted_111
]
const _hoisted_113 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "add-icon"
}, null, -1)
const _hoisted_114 = ["onClick"]
const _hoisted_115 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "close"
}, null, -1)
const _hoisted_116 = [
  _hoisted_115
]
const _hoisted_117 = ["onClick"]
const _hoisted_118 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "remove-icon"
}, null, -1)
const _hoisted_119 = /*#__PURE__*/_createElementVNode("button", null, "Delete", -1)
const _hoisted_120 = [
  _hoisted_118,
  _hoisted_119
]
const _hoisted_121 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "add-icon"
}, null, -1)
const _hoisted_122 = ["onClick"]
const _hoisted_123 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "close"
}, null, -1)
const _hoisted_124 = [
  _hoisted_123
]
const _hoisted_125 = ["onClick"]
const _hoisted_126 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "remove-icon"
}, null, -1)
const _hoisted_127 = /*#__PURE__*/_createElementVNode("button", null, "Delete", -1)
const _hoisted_128 = [
  _hoisted_126,
  _hoisted_127
]
const _hoisted_129 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "add-icon"
}, null, -1)
const _hoisted_130 = ["onClick"]
const _hoisted_131 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "close"
}, null, -1)
const _hoisted_132 = [
  _hoisted_131
]
const _hoisted_133 = ["onClick"]
const _hoisted_134 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "remove-icon"
}, null, -1)
const _hoisted_135 = /*#__PURE__*/_createElementVNode("button", null, "Delete", -1)
const _hoisted_136 = [
  _hoisted_134,
  _hoisted_135
]
const _hoisted_137 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "add-icon"
}, null, -1)
const _hoisted_138 = ["onClick"]
const _hoisted_139 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "close"
}, null, -1)
const _hoisted_140 = [
  _hoisted_139
]
const _hoisted_141 = ["onClick"]
const _hoisted_142 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "remove-icon"
}, null, -1)
const _hoisted_143 = /*#__PURE__*/_createElementVNode("button", null, "Delete", -1)
const _hoisted_144 = [
  _hoisted_142,
  _hoisted_143
]
const _hoisted_145 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "add-icon"
}, null, -1)
const _hoisted_146 = ["onClick"]
const _hoisted_147 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "close"
}, null, -1)
const _hoisted_148 = [
  _hoisted_147
]
const _hoisted_149 = ["onClick"]
const _hoisted_150 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "remove-icon"
}, null, -1)
const _hoisted_151 = /*#__PURE__*/_createElementVNode("button", null, "Delete", -1)
const _hoisted_152 = [
  _hoisted_150,
  _hoisted_151
]
const _hoisted_153 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "add-icon"
}, null, -1)

import { computed } from "vue";
import * as rules from "@/utils/rules";
import DateInput from "../custom/DateInput.vue";
import VisionVariables from "@/types/VisionVariables";
import VisionItem from "@/types/VisionItem";
import VisionClaimItems from "@/types/VisionClaimItems";
import FormTitle from "../common/FormTItle.vue";
import VisionProvider from "@/types/VisionProvider";
import NumberInput from "../custom/NumberInput.vue";
import CurrencyInput from "../custom/CurrencyInput.vue";
import NotificationBanner from "../common/NotificationBanner.vue";
import CheckBox from "../custom/CheckBox.vue";

enum LensType {
  SingleVision = "singleVision",
  Bifocal = "bifocal",
  Trifocal = "trifocal",
  Progressive = "progressive",
  Lenticular = "lenticular",
  OtherLenses = "otherLenses",
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ClaimInformation',
  props: {
    modelValue: {},
    claimItems: {},
    validateMethod: { type: Function },
    providers: {}
  },
  emits: ["update:modelValue", "update:claimItems"],
  setup(__props: any, { emit }) {

const props = __props;



const selectedProvider = computed(() =>
  props.providers.find(
    (provider) => provider.name === variables.value.planAdministrator
  )
);

const formOptions = computed(() => selectedProvider.value?.formOptions || {});

const checkBoxRules = {
  atLeastOneCheckbox: () => {
    const checked =
      variables.value?.exam ||
      variables.value?.frames ||
      (variables.value?.lenses &&
        (variables.value?.singleVision ||
          variables.value?.bifocal ||
          variables.value?.trifocal ||
          variables.value?.progressive ||
          variables.value?.lenticular ||
          variables.value?.otherLenses)) ||
      (variables.value?.lensOptions &&
        (variables.value?.otherLensOption ||
          variables.value?.tint ||
          variables.value?.coating ||
          variables.value?.polycarbonate ||
          variables.value?.antiReflective ||
          variables.value?.UV ||
          variables.value?.scratchResistant ||
          variables.value?.rollAndPolish)) ||
      variables.value?.contacts ||
      variables.value?.contactFitting ||
      false;
    return checked ? true : "At least one checkbox must be checked";
  },
};

// return checked name of one lens type
const getCheckedOptionName = () => {
  if (variables.value.singleVision) return LensType.SingleVision;
  if (variables.value.bifocal) return LensType.Bifocal;
  if (variables.value.trifocal) return LensType.Trifocal;
  if (variables.value.progressive) return LensType.Progressive;
  if (variables.value.lenticular) return LensType.Lenticular;
  if (variables.value.otherLenses) return LensType.OtherLenses;
  return "";
};



const variables = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

const items = computed({
  get() {
    return props.claimItems;
  },
  set(value) {
    emit("update:claimItems", value);
  },
});

const atLeastOneChecked = computed(() => {
  return (
    variables.value?.singleVision ||
    variables.value?.bifocal ||
    variables.value?.trifocal ||
    variables.value?.progressive ||
    variables.value?.lenticular ||
    variables.value?.otherLenses ||
    false
  );
});

function cleanAmountsForonlyOneLensTypeTPA() {
  if (formOptions.value.onlyOneLensType) {
    if (getCheckedOptionName() !== LensType.SingleVision) {
      items.value.singleVision;
      variables.value.singleVisionAmount = 0;
      items.value.singleVision = [];
      items.value.singleVision.push({ ...emptyItem });
    }

    if (getCheckedOptionName() !== LensType.Bifocal) {
      variables.value.bifocalAmount = 0;
      items.value.bifocal = [];
      items.value.bifocal.push({ ...emptyItem });
    }

    if (getCheckedOptionName() !== LensType.Trifocal) {
      variables.value.trifocalAmount = 0;
      items.value.trifocal = [];
      items.value.trifocal.push({ ...emptyItem });
    }

    if (getCheckedOptionName() !== LensType.Progressive) {
      variables.value.progressiveAmount = 0;
      items.value.progressive = [];
      items.value.progressive.push({ ...emptyItem });
    }

    if (getCheckedOptionName() !== LensType.Lenticular) {
      variables.value.lenticularAmount = 0;
      items.value.lenticular = [];
      items.value.lenticular.push({ ...emptyItem });
    }

    if (getCheckedOptionName() !== LensType.OtherLenses) {
      variables.value.otherLensesAmount = 0;
      items.value.otherLenses = [];
      items.value.otherLenses.push({ ...emptyItem });
    }
  }
}
const today = new Date();
const emptyItem = {
  date: variables.value.serviceDate || today.toLocaleDateString("en-US"),
  amount: 0.0,
};

function validateMethod() {
  cleanAmountsForonlyOneLensTypeTPA();
  // Perform validation using the props.validateMethod
  if (props.validateMethod) {
    props.validateMethod().then((isValid) => {
      if (!isValid) {
        // Handle validation failure if needed
      }
    });
  }
}

function deleteItem(index: number, items: VisionItem[]) {
  if (index >= 0 && index < items.length && items.length >= 2) {
    items.splice(index, 1);
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_input = _resolveComponent("v-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_col, {
      cols: "12",
      style: {"padding-bottom":"40px !important"}
    }, {
      default: _withCtx(() => [
        _createVNode(FormTitle, {
          title: "Claim Information",
          description: "Give us some information about the reimbursement claim"
        }),
        _createVNode(NotificationBanner, {
          title: "What should I claim?",
          description: "For vision insurance, you can claim the item cost and any shipping you paid, but not the taxes. We suggest adding the shipping cost to the highest priced item you purchased."
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_col, { cols: "12" }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode(_component_v_col, { cols: "12" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "claim-item-container" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                (variables.value.exam)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(items.value.exam, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "item-container"
                      }, [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "12",
                          md: "6",
                          lg: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(DateInput, {
                              label: "Exam date",
                              modelValue: item.date,
                              "onUpdate:modelValue": ($event: any) => ((item.date) = $event),
                              class: "item-input",
                              rules: [rules.requiredRule]
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "12",
                          md: "5",
                          lg: "5",
                          style: {"padding-bottom":"0%"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(CurrencyInput, {
                              label: "Exam Cost",
                              class: "item-input",
                              modelValue: item.amount,
                              "onUpdate:modelValue": ($event: any) => ((item.amount) = $event),
                              rules: [rules.requiredRule]
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                          ]),
                          _: 2
                        }, 1024),
                        (items.value.exam.length > 1)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "x-btn",
                              onClick: ($event: any) => (deleteItem(index, items.value.exam))
                            }, _hoisted_4, 8, _hoisted_2))
                          : _createCommentVNode("", true),
                        (items.value.exam.length > 1)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              onClick: ($event: any) => (deleteItem(index, items.value.exam)),
                              style: {"display":"flex"},
                              class: "delete-item-btn"
                            }, _hoisted_8, 8, _hoisted_5))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (variables.value.exam)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (items.value.exam.push({ ...emptyItem }))),
                  class: "add-item-btn"
                }, {
                  default: _withCtx(() => [
                    _hoisted_9,
                    _createTextVNode(" Add another item ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_col, { cols: "12" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "claim-item-container" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(CheckBox, {
                      onChange: validateMethod,
                      label: "Frames",
                      modelValue: variables.value.frames,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((variables.value.frames) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                (variables.value.frames)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(items.value.frames, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "item-container"
                      }, [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "12",
                          md: "6",
                          lg: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(DateInput, {
                              label: "Purchase",
                              modelValue: item.date,
                              "onUpdate:modelValue": ($event: any) => ((item.date) = $event),
                              class: "item-input"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "12",
                          md: "5",
                          lg: "5",
                          style: {"padding-bottom":"0%"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(CurrencyInput, {
                              label: "Frames Cost",
                              class: "item-input",
                              modelValue: item.amount,
                              "onUpdate:modelValue": ($event: any) => ((item.amount) = $event),
                              rules: [rules.requiredRule]
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                          ]),
                          _: 2
                        }, 1024),
                        (items.value.frames.length > 1)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "x-btn",
                              onClick: ($event: any) => (deleteItem(index, items.value.frames))
                            }, _hoisted_12, 8, _hoisted_10))
                          : _createCommentVNode("", true),
                        (items.value.frames.length > 1)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              onClick: ($event: any) => (deleteItem(index, items.value.frames)),
                              style: {"display":"flex"},
                              class: "delete-item-btn"
                            }, _hoisted_16, 8, _hoisted_13))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (variables.value.frames)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (items.value.frames.push({ ...emptyItem }))),
                  class: "add-item-btn"
                }, {
                  default: _withCtx(() => [
                    _hoisted_17,
                    _createTextVNode(" Add another item ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_col, { cols: "12" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "claim-item-container" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "p-5"
                }, {
                  default: _withCtx(() => [
                    _createVNode(CheckBox, {
                      onChange: validateMethod,
                      label: "Lenses",
                      modelValue: variables.value.lenses,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((variables.value.lenses) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (
          !variables.value.singleVision &&
          formOptions.value.onlyOneLensType &&
          atLeastOneChecked.value
        )
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
              : _createCommentVNode("", true),
            (variables.value.lenses)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: "lens-option-container",
                        disabled: 
              !variables.value.singleVision &&
              formOptions.value.onlyOneLensType &&
              atLeastOneChecked.value
            
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "12" }, {
                                default: _withCtx(() => [
                                  _createVNode(CheckBox, {
                                    onChange: validateMethod,
                                    label: "Single Vision",
                                    modelValue: variables.value.singleVision,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((variables.value.singleVision) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              (variables.value.singleVision)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value.singleVision, (item, index) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: index,
                                        class: "item-container"
                                      }, [
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          sm: "12",
                                          md: "6",
                                          lg: "6"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(DateInput, {
                                              label: "Purchase date",
                                              modelValue: item.date,
                                              "onUpdate:modelValue": ($event: any) => ((item.date) = $event),
                                              class: "item-input"
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          sm: "12",
                                          md: "5",
                                          lg: "5",
                                          style: {"padding-bottom":"0%"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(CurrencyInput, {
                                              label: "Cost",
                                              class: "item-input",
                                              modelValue: item.amount,
                                              "onUpdate:modelValue": ($event: any) => ((item.amount) = $event),
                                              rules: [rules.requiredRule]
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                                          ]),
                                          _: 2
                                        }, 1024),
                                        (items.value.singleVision.length > 1)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              class: "x-btn",
                                              onClick: ($event: any) => (deleteItem(index, items.value.singleVision))
                                            }, _hoisted_23, 8, _hoisted_21))
                                          : _createCommentVNode("", true),
                                        (items.value.singleVision.length > 1)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 1,
                                              onClick: ($event: any) => (deleteItem(index, items.value.singleVision)),
                                              style: {"display":"flex"},
                                              class: "delete-item-btn"
                                            }, _hoisted_27, 8, _hoisted_24))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128)),
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      style: {"width":"100%","padding":"0 !important"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn, {
                                          onClick: _cache[5] || (_cache[5] = ($event: any) => (items.value.singleVision.push({ ...emptyItem }))),
                                          class: "add-item-btn"
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_28,
                                            _createTextVNode(" Add another item ")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: "lens-option-container",
                        disabled: 
              !variables.value.bifocal &&
              formOptions.value.onlyOneLensType &&
              atLeastOneChecked.value
            
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "12" }, {
                                default: _withCtx(() => [
                                  _createVNode(CheckBox, {
                                    onChange: validateMethod,
                                    label: "Bifocal",
                                    modelValue: variables.value.bifocal,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((variables.value.bifocal) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              (variables.value.bifocal)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value.bifocal, (item, index) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: index,
                                        class: "item-container"
                                      }, [
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          sm: "12",
                                          md: "6",
                                          lg: "6"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(DateInput, {
                                              label: "Purchase date",
                                              modelValue: item.date,
                                              "onUpdate:modelValue": ($event: any) => ((item.date) = $event),
                                              class: "item-input"
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          sm: "12",
                                          md: "5",
                                          lg: "5",
                                          style: {"padding-bottom":"0%"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(CurrencyInput, {
                                              label: "Cost",
                                              class: "item-input",
                                              modelValue: item.amount,
                                              "onUpdate:modelValue": ($event: any) => ((item.amount) = $event),
                                              rules: [rules.requiredRule]
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                                          ]),
                                          _: 2
                                        }, 1024),
                                        (items.value.bifocal.length > 1)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              class: "x-btn",
                                              onClick: ($event: any) => (deleteItem(index, items.value.bifocal))
                                            }, _hoisted_31, 8, _hoisted_29))
                                          : _createCommentVNode("", true),
                                        (items.value.bifocal.length > 1)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 1,
                                              onClick: ($event: any) => (deleteItem(index, items.value.bifocal)),
                                              style: {"display":"flex"},
                                              class: "delete-item-btn"
                                            }, _hoisted_35, 8, _hoisted_32))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128)),
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      style: {"width":"100%","padding":"0 !important"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn, {
                                          onClick: _cache[7] || (_cache[7] = ($event: any) => (items.value.bifocal.push({ ...emptyItem }))),
                                          class: "add-item-btn"
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_36,
                                            _createTextVNode(" Add another item ")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: "lens-option-container",
                        disabled: 
              !variables.value.trifocal &&
              formOptions.value.onlyOneLensType &&
              atLeastOneChecked.value
            
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "12" }, {
                                default: _withCtx(() => [
                                  _createVNode(CheckBox, {
                                    onChange: validateMethod,
                                    label: "Trifocal",
                                    modelValue: variables.value.trifocal,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((variables.value.trifocal) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              (variables.value.trifocal)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value.trifocal, (item, index) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: index,
                                        class: "item-container"
                                      }, [
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          sm: "12",
                                          md: "6",
                                          lg: "6"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(DateInput, {
                                              label: "Purchase date",
                                              modelValue: item.date,
                                              "onUpdate:modelValue": ($event: any) => ((item.date) = $event),
                                              class: "item-input"
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          sm: "12",
                                          md: "5",
                                          lg: "5",
                                          style: {"padding-bottom":"0%"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(CurrencyInput, {
                                              label: "Cost",
                                              class: "item-input",
                                              modelValue: item.amount,
                                              "onUpdate:modelValue": ($event: any) => ((item.amount) = $event),
                                              rules: [rules.requiredRule]
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                                          ]),
                                          _: 2
                                        }, 1024),
                                        (items.value.trifocal.length > 1)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              class: "x-btn",
                                              onClick: ($event: any) => (deleteItem(index, items.value.trifocal))
                                            }, _hoisted_39, 8, _hoisted_37))
                                          : _createCommentVNode("", true),
                                        (items.value.trifocal.length > 1)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 1,
                                              onClick: ($event: any) => (deleteItem(index, items.value.trifocal)),
                                              style: {"display":"flex"},
                                              class: "delete-item-btn"
                                            }, _hoisted_43, 8, _hoisted_40))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128)),
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      style: {"width":"100%","padding":"0 !important"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn, {
                                          onClick: _cache[9] || (_cache[9] = ($event: any) => (items.value.trifocal.push({ ...emptyItem }))),
                                          class: "add-item-btn"
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_44,
                                            _createTextVNode(" Add another item ")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: "lens-option-container",
                        disabled: 
              !variables.value.lenticular &&
              formOptions.value.onlyOneLensType &&
              atLeastOneChecked.value
            
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "12" }, {
                                default: _withCtx(() => [
                                  _createVNode(CheckBox, {
                                    onChange: validateMethod,
                                    label: "Lenticular",
                                    modelValue: variables.value.lenticular,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((variables.value.lenticular) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              (variables.value.lenticular)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value.lenticular, (item, index) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: index,
                                        class: "item-container"
                                      }, [
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          sm: "12",
                                          md: "6",
                                          lg: "6"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(DateInput, {
                                              label: "Purchase date",
                                              modelValue: item.date,
                                              "onUpdate:modelValue": ($event: any) => ((item.date) = $event),
                                              class: "item-input"
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          sm: "12",
                                          md: "5",
                                          lg: "5",
                                          style: {"padding-bottom":"0%"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(CurrencyInput, {
                                              label: "Cost",
                                              class: "item-input",
                                              modelValue: item.amount,
                                              "onUpdate:modelValue": ($event: any) => ((item.amount) = $event),
                                              rules: [rules.requiredRule]
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                                          ]),
                                          _: 2
                                        }, 1024),
                                        (items.value.lenticular.length > 1)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              class: "x-btn",
                                              onClick: ($event: any) => (deleteItem(index, items.value.lenticular))
                                            }, _hoisted_47, 8, _hoisted_45))
                                          : _createCommentVNode("", true),
                                        (items.value.lenticular.length > 1)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 1,
                                              onClick: ($event: any) => (deleteItem(index, items.value.lenticular)),
                                              style: {"display":"flex"},
                                              class: "delete-item-btn"
                                            }, _hoisted_51, 8, _hoisted_48))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128)),
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      style: {"width":"100%","padding":"0 !important"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn, {
                                          onClick: _cache[11] || (_cache[11] = ($event: any) => (items.value.lenticular.push({ ...emptyItem }))),
                                          class: "add-item-btn"
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_52,
                                            _createTextVNode(" Add another item ")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: "lens-option-container",
                        disabled: 
              !variables.value.progressive &&
              formOptions.value.onlyOneLensType &&
              atLeastOneChecked.value
            
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "12" }, {
                                default: _withCtx(() => [
                                  _createVNode(CheckBox, {
                                    onChange: validateMethod,
                                    label: "Progressive",
                                    modelValue: variables.value.progressive,
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((variables.value.progressive) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              (variables.value.progressive)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value.progressive, (item, index) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: index,
                                        class: "item-container"
                                      }, [
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          sm: "12",
                                          md: "6",
                                          lg: "6"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(DateInput, {
                                              label: "Purchase date",
                                              modelValue: item.date,
                                              "onUpdate:modelValue": ($event: any) => ((item.date) = $event),
                                              class: "item-input"
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          sm: "12",
                                          md: "5",
                                          lg: "5",
                                          style: {"padding-bottom":"0%"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(CurrencyInput, {
                                              label: "Cost",
                                              class: "item-input",
                                              modelValue: item.amount,
                                              "onUpdate:modelValue": ($event: any) => ((item.amount) = $event),
                                              rules: [rules.requiredRule]
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                                          ]),
                                          _: 2
                                        }, 1024),
                                        (items.value.progressive.length > 1)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              class: "x-btn",
                                              onClick: ($event: any) => (deleteItem(index, items.value.progressive))
                                            }, _hoisted_55, 8, _hoisted_53))
                                          : _createCommentVNode("", true),
                                        (items.value.progressive.length > 1)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 1,
                                              onClick: ($event: any) => (deleteItem(index, items.value.progressive)),
                                              style: {"display":"flex"},
                                              class: "delete-item-btn"
                                            }, _hoisted_59, 8, _hoisted_56))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128)),
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      style: {"width":"100%","padding":"0 !important"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn, {
                                          onClick: _cache[13] || (_cache[13] = ($event: any) => (items.value.progressive.push({ ...emptyItem }))),
                                          class: "add-item-btn"
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_60,
                                            _createTextVNode(" Add another item ")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: "lens-option-container",
                        disabled: 
              !variables.value.otherLenses &&
              formOptions.value.onlyOneLensType &&
              atLeastOneChecked.value
            
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "12" }, {
                                default: _withCtx(() => [
                                  _createVNode(CheckBox, {
                                    onChange: validateMethod,
                                    label: "Other lenses",
                                    modelValue: variables.value.otherLenses,
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((variables.value.otherLenses) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              (variables.value.otherLenses)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value.otherLenses, (item, index) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: index,
                                        class: "item-container"
                                      }, [
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          sm: "12",
                                          md: "6",
                                          lg: "6"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(DateInput, {
                                              label: "Purchase date",
                                              modelValue: item.date,
                                              "onUpdate:modelValue": ($event: any) => ((item.date) = $event),
                                              class: "item-input"
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          sm: "12",
                                          md: "5",
                                          lg: "5",
                                          style: {"padding-bottom":"0%"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(CurrencyInput, {
                                              label: "Cost",
                                              class: "item-input",
                                              modelValue: item.amount,
                                              "onUpdate:modelValue": ($event: any) => ((item.amount) = $event),
                                              rules: [rules.requiredRule]
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                                          ]),
                                          _: 2
                                        }, 1024),
                                        (items.value.otherLenses.length > 1)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              class: "x-btn",
                                              onClick: ($event: any) => (deleteItem(index, items.value.otherLenses))
                                            }, _hoisted_63, 8, _hoisted_61))
                                          : _createCommentVNode("", true),
                                        (items.value.otherLenses.length > 1)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 1,
                                              onClick: ($event: any) => (deleteItem(index, items.value.otherLenses)),
                                              style: {"display":"flex"},
                                              class: "delete-item-btn"
                                            }, _hoisted_67, 8, _hoisted_64))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128)),
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      style: {"width":"100%","padding":"0 !important"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn, {
                                          onClick: _cache[15] || (_cache[15] = ($event: any) => (items.value.otherLenses.push({ ...emptyItem }))),
                                          class: "add-item-btn"
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_68,
                                            _createTextVNode(" Add another item ")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_col, { cols: "12" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "claim-item-container" }, {
          default: _withCtx(() => [
            _createVNode(CheckBox, {
              onChange: validateMethod,
              label: "Lens Options",
              modelValue: variables.value.lensOptions,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((variables.value.lensOptions) = $event))
            }, null, 8, ["modelValue"]),
            (variables.value.lensOptions)
              ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, { class: "lens-option-container" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(CheckBox, {
                                      onChange: validateMethod,
                                      label: "Coating",
                                      modelValue: variables.value.coating,
                                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((variables.value.coating) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                (variables.value.coating)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value.coating, (item, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: index,
                                          class: "item-container"
                                        }, [
                                          _createVNode(_component_v_col, {
                                            cols: "12",
                                            sm: "12",
                                            md: "6",
                                            lg: "6"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(DateInput, {
                                                label: "Purchase date",
                                                modelValue: item.date,
                                                "onUpdate:modelValue": ($event: any) => ((item.date) = $event),
                                                class: "item-input"
                                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_v_col, {
                                            cols: "12",
                                            sm: "12",
                                            md: "5",
                                            lg: "5",
                                            style: {"padding-bottom":"0%"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(CurrencyInput, {
                                                label: "Cost",
                                                class: "item-input",
                                                modelValue: item.amount,
                                                "onUpdate:modelValue": ($event: any) => ((item.amount) = $event),
                                                rules: [rules.requiredRule]
                                              }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                                            ]),
                                            _: 2
                                          }, 1024),
                                          (items.value.coating.length > 1)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 0,
                                                class: "x-btn",
                                                onClick: ($event: any) => (deleteItem(index, items.value.coating))
                                              }, _hoisted_71, 8, _hoisted_69))
                                            : _createCommentVNode("", true),
                                          (items.value.coating.length > 1)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 1,
                                                onClick: ($event: any) => (deleteItem(index, items.value.coating)),
                                                style: {"display":"flex"},
                                                class: "delete-item-btn"
                                              }, _hoisted_75, 8, _hoisted_72))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128)),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        style: {"width":"100%","padding":"0 !important"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_btn, {
                                            onClick: _cache[18] || (_cache[18] = ($event: any) => (items.value.coating.push({ ...emptyItem }))),
                                            class: "add-item-btn"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_76,
                                              _createTextVNode(" Add another item ")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, { class: "lens-option-container" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(CheckBox, {
                                      onChange: validateMethod,
                                      label: "Tint",
                                      modelValue: variables.value.tint,
                                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((variables.value.tint) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                (variables.value.tint)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value.tint, (item, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: index,
                                          class: "item-container"
                                        }, [
                                          _createVNode(_component_v_col, {
                                            cols: "12",
                                            sm: "12",
                                            md: "6",
                                            lg: "6"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(DateInput, {
                                                label: "Purchase date",
                                                modelValue: item.date,
                                                "onUpdate:modelValue": ($event: any) => ((item.date) = $event),
                                                class: "item-input"
                                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_v_col, {
                                            cols: "12",
                                            sm: "12",
                                            md: "5",
                                            lg: "5",
                                            style: {"padding-bottom":"0%"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(CurrencyInput, {
                                                label: "Cost",
                                                class: "item-input",
                                                modelValue: item.amount,
                                                "onUpdate:modelValue": ($event: any) => ((item.amount) = $event),
                                                rules: [rules.requiredRule]
                                              }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                                            ]),
                                            _: 2
                                          }, 1024),
                                          (items.value.tint.length > 1)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 0,
                                                class: "x-btn",
                                                onClick: ($event: any) => (deleteItem(index, items.value.tint))
                                              }, _hoisted_79, 8, _hoisted_77))
                                            : _createCommentVNode("", true),
                                          (items.value.tint.length > 1)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 1,
                                                onClick: ($event: any) => (deleteItem(index, items.value.tint)),
                                                style: {"display":"flex"},
                                                class: "delete-item-btn"
                                              }, _hoisted_83, 8, _hoisted_80))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128)),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        style: {"width":"100%","padding":"0 !important"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_btn, {
                                            onClick: _cache[20] || (_cache[20] = ($event: any) => (items.value.tint.push({ ...emptyItem }))),
                                            class: "add-item-btn"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_84,
                                              _createTextVNode(" Add another item ")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, { class: "lens-option-container" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(CheckBox, {
                                      onChange: validateMethod,
                                      label: "Anti Reflective",
                                      modelValue: variables.value.antiReflective,
                                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((variables.value.antiReflective) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                (variables.value.antiReflective)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value.antiReflective, (item, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: index,
                                          class: "item-container"
                                        }, [
                                          _createVNode(_component_v_col, {
                                            cols: "12",
                                            sm: "12",
                                            md: "6",
                                            lg: "6"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(DateInput, {
                                                label: "Purchase date",
                                                modelValue: item.date,
                                                "onUpdate:modelValue": ($event: any) => ((item.date) = $event),
                                                class: "item-input"
                                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_v_col, {
                                            cols: "12",
                                            sm: "12",
                                            md: "5",
                                            lg: "5",
                                            style: {"padding-bottom":"0%"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(CurrencyInput, {
                                                label: "Cost",
                                                class: "item-input",
                                                modelValue: item.amount,
                                                "onUpdate:modelValue": ($event: any) => ((item.amount) = $event),
                                                rules: [rules.requiredRule]
                                              }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                                            ]),
                                            _: 2
                                          }, 1024),
                                          (items.value.antiReflective.length > 1)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 0,
                                                class: "x-btn",
                                                onClick: ($event: any) => (deleteItem(index, items.value.antiReflective))
                                              }, _hoisted_87, 8, _hoisted_85))
                                            : _createCommentVNode("", true),
                                          (items.value.antiReflective.length > 1)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 1,
                                                onClick: ($event: any) => (deleteItem(index, items.value.antiReflective)),
                                                style: {"display":"flex"},
                                                class: "delete-item-btn"
                                              }, _hoisted_91, 8, _hoisted_88))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128)),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        style: {"width":"100%","padding":"0 !important"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_btn, {
                                            onClick: _cache[22] || (_cache[22] = ($event: any) => (items.value.antiReflective.push({ ...emptyItem }))),
                                            class: "add-item-btn"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_92,
                                              _createTextVNode(" Add another item ")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, { class: "lens-option-container" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(CheckBox, {
                                      onChange: validateMethod,
                                      label: "Polycarbonate",
                                      modelValue: variables.value.polycarbonate,
                                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((variables.value.polycarbonate) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                (variables.value.polycarbonate)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value.polycarbonate, (item, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: index,
                                          class: "item-container"
                                        }, [
                                          _createVNode(_component_v_col, {
                                            cols: "12",
                                            sm: "12",
                                            md: "6",
                                            lg: "6"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(DateInput, {
                                                label: "Purchase date",
                                                modelValue: item.date,
                                                "onUpdate:modelValue": ($event: any) => ((item.date) = $event),
                                                class: "item-input"
                                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_v_col, {
                                            cols: "12",
                                            sm: "12",
                                            md: "5",
                                            lg: "5",
                                            style: {"padding-bottom":"0%"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(CurrencyInput, {
                                                label: "Cost",
                                                class: "item-input",
                                                modelValue: item.amount,
                                                "onUpdate:modelValue": ($event: any) => ((item.amount) = $event),
                                                rules: [rules.requiredRule]
                                              }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                                            ]),
                                            _: 2
                                          }, 1024),
                                          (items.value.polycarbonate.length > 1)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 0,
                                                class: "x-btn",
                                                onClick: ($event: any) => (deleteItem(index, items.value.polycarbonate))
                                              }, _hoisted_95, 8, _hoisted_93))
                                            : _createCommentVNode("", true),
                                          (items.value.polycarbonate.length > 1)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 1,
                                                onClick: ($event: any) => (deleteItem(index, items.value.polycarbonate)),
                                                style: {"display":"flex"},
                                                class: "delete-item-btn"
                                              }, _hoisted_99, 8, _hoisted_96))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128)),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        style: {"width":"100%","padding":"0 !important"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_btn, {
                                            onClick: _cache[24] || (_cache[24] = ($event: any) => (items.value.polycarbonate.push({ ...emptyItem }))),
                                            class: "add-item-btn"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_100,
                                              _createTextVNode(" Add another item ")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, { class: "lens-option-container" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(CheckBox, {
                                      onChange: validateMethod,
                                      label: "Scratch Resistant",
                                      modelValue: variables.value.scratchResistant,
                                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((variables.value.scratchResistant) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                (variables.value.scratchResistant)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value.scratchResistant, (item, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: index,
                                          class: "item-container"
                                        }, [
                                          _createVNode(_component_v_col, {
                                            cols: "12",
                                            sm: "12",
                                            md: "6",
                                            lg: "6"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(DateInput, {
                                                label: "Purchase date",
                                                modelValue: item.date,
                                                "onUpdate:modelValue": ($event: any) => ((item.date) = $event),
                                                class: "item-input"
                                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_v_col, {
                                            cols: "12",
                                            sm: "12",
                                            md: "5",
                                            lg: "5",
                                            style: {"padding-bottom":"0%"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(CurrencyInput, {
                                                label: "Cost",
                                                class: "item-input",
                                                modelValue: item.amount,
                                                "onUpdate:modelValue": ($event: any) => ((item.amount) = $event),
                                                rules: [rules.requiredRule]
                                              }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                                            ]),
                                            _: 2
                                          }, 1024),
                                          (items.value.scratchResistant.length > 1)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 0,
                                                class: "x-btn",
                                                onClick: ($event: any) => (deleteItem(index, items.value.scratchResistant))
                                              }, _hoisted_103, 8, _hoisted_101))
                                            : _createCommentVNode("", true),
                                          (items.value.scratchResistant.length > 1)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 1,
                                                onClick: ($event: any) => (deleteItem(index, items.value.scratchResistant)),
                                                style: {"display":"flex"},
                                                class: "delete-item-btn"
                                              }, _hoisted_107, 8, _hoisted_104))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128)),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        style: {"width":"100%","padding":"0 !important"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_btn, {
                                            onClick: _cache[26] || (_cache[26] = ($event: any) => (items.value.scratchResistant.push({ ...emptyItem }))),
                                            class: "add-item-btn"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_108,
                                              _createTextVNode(" Add another item ")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, { class: "lens-option-container" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(CheckBox, {
                                      onChange: validateMethod,
                                      label: "UV",
                                      modelValue: variables.value.UV,
                                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((variables.value.UV) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                (variables.value.UV)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value.UV, (item, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: index,
                                          class: "item-container"
                                        }, [
                                          _createVNode(_component_v_col, {
                                            cols: "12",
                                            sm: "12",
                                            md: "6",
                                            lg: "6"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(DateInput, {
                                                label: "Purchase date",
                                                modelValue: item.date,
                                                "onUpdate:modelValue": ($event: any) => ((item.date) = $event),
                                                class: "item-input"
                                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_v_col, {
                                            cols: "12",
                                            sm: "12",
                                            md: "5",
                                            lg: "5",
                                            style: {"padding-bottom":"0%"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(CurrencyInput, {
                                                label: "Cost",
                                                class: "item-input",
                                                modelValue: item.amount,
                                                "onUpdate:modelValue": ($event: any) => ((item.amount) = $event),
                                                rules: [rules.requiredRule]
                                              }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                                            ]),
                                            _: 2
                                          }, 1024),
                                          (items.value.UV.length > 1)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 0,
                                                onClick: ($event: any) => (deleteItem(index, items.value.UV)),
                                                style: {"display":"flex"},
                                                class: "delete-item-btn"
                                              }, _hoisted_112, 8, _hoisted_109))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128)),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        style: {"width":"100%","padding":"0 !important"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_btn, {
                                            onClick: _cache[28] || (_cache[28] = ($event: any) => (items.value.UV.push({ ...emptyItem }))),
                                            class: "add-item-btn"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_113,
                                              _createTextVNode(" Add another item ")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, { class: "lens-option-container" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(CheckBox, {
                                      onChange: validateMethod,
                                      label: "Roll and Polish",
                                      modelValue: variables.value.rollAndPolish,
                                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((variables.value.rollAndPolish) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                (variables.value.rollAndPolish)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value.rollAndPolish, (item, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: index,
                                          class: "item-container"
                                        }, [
                                          _createVNode(_component_v_col, {
                                            cols: "12",
                                            sm: "12",
                                            md: "6",
                                            lg: "6"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(DateInput, {
                                                label: "Purchase date",
                                                modelValue: item.date,
                                                "onUpdate:modelValue": ($event: any) => ((item.date) = $event),
                                                class: "item-input"
                                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_v_col, {
                                            cols: "12",
                                            sm: "12",
                                            md: "5",
                                            lg: "5",
                                            style: {"padding-bottom":"0%"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(CurrencyInput, {
                                                label: "Cost",
                                                class: "item-input",
                                                modelValue: item.amount,
                                                "onUpdate:modelValue": ($event: any) => ((item.amount) = $event),
                                                rules: [rules.requiredRule]
                                              }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                                            ]),
                                            _: 2
                                          }, 1024),
                                          (items.value.rollAndPolish.length > 1)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 0,
                                                class: "x-btn",
                                                onClick: ($event: any) => (deleteItem(index, items.value.rollAndPolish))
                                              }, _hoisted_116, 8, _hoisted_114))
                                            : _createCommentVNode("", true),
                                          (items.value.rollAndPolish.length > 1)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 1,
                                                onClick: ($event: any) => (deleteItem(index, items.value.rollAndPolish)),
                                                style: {"display":"flex"},
                                                class: "delete-item-btn"
                                              }, _hoisted_120, 8, _hoisted_117))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128)),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        style: {"width":"100%","padding":"0 !important"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_btn, {
                                            onClick: _cache[30] || (_cache[30] = ($event: any) => (items.value.rollAndPolish.push({ ...emptyItem }))),
                                            class: "add-item-btn"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_121,
                                              _createTextVNode(" Add another item ")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, { class: "lens-option-container" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(CheckBox, {
                                      onChange: validateMethod,
                                      label: "Other Lens Option",
                                      modelValue: variables.value.otherLensOption,
                                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((variables.value.otherLensOption) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                (variables.value.otherLensOption)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value.otherLensOption, (item, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: index,
                                          class: "item-container"
                                        }, [
                                          _createVNode(_component_v_col, {
                                            cols: "12",
                                            sm: "12",
                                            md: "6",
                                            lg: "6"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(DateInput, {
                                                label: "Purchase date",
                                                modelValue: item.date,
                                                "onUpdate:modelValue": ($event: any) => ((item.date) = $event),
                                                class: "item-input"
                                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_v_col, {
                                            cols: "12",
                                            sm: "12",
                                            md: "5",
                                            lg: "5",
                                            style: {"padding-bottom":"0%"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(CurrencyInput, {
                                                label: "Cost",
                                                class: "item-input",
                                                modelValue: item.amount,
                                                "onUpdate:modelValue": ($event: any) => ((item.amount) = $event),
                                                rules: [rules.requiredRule]
                                              }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                                            ]),
                                            _: 2
                                          }, 1024),
                                          (items.value.otherLensOption.length > 1)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 0,
                                                class: "x-btn",
                                                onClick: ($event: any) => (deleteItem(index, items.value.otherLensOption))
                                              }, _hoisted_124, 8, _hoisted_122))
                                            : _createCommentVNode("", true),
                                          (items.value.otherLensOption.length > 1)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 1,
                                                onClick: ($event: any) => (deleteItem(index, items.value.otherLensOption)),
                                                style: {"display":"flex"},
                                                class: "delete-item-btn"
                                              }, _hoisted_128, 8, _hoisted_125))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128)),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        style: {"width":"100%","padding":"0 !important"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_btn, {
                                            onClick: _cache[32] || (_cache[32] = ($event: any) => (items.value.otherLensOption.push({ ...emptyItem }))),
                                            class: "add-item-btn"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_129,
                                              _createTextVNode(" Add another item ")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_col, { cols: "12" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "claim-item-container" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(CheckBox, {
                      onChange: validateMethod,
                      label: "Contacts",
                      modelValue: variables.value.contacts,
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((variables.value.contacts) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                (variables.value.contacts)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value.contacts, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "item-container"
                        }, [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            sm: "12",
                            md: "6",
                            lg: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(DateInput, {
                                label: "Purchase date",
                                modelValue: item.date,
                                "onUpdate:modelValue": ($event: any) => ((item.date) = $event),
                                class: "item-input"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            sm: "12",
                            md: "5",
                            lg: "5",
                            style: {"padding-bottom":"0%"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(CurrencyInput, {
                                label: "Contacts Cost",
                                class: "item-input",
                                modelValue: item.amount,
                                "onUpdate:modelValue": ($event: any) => ((item.amount) = $event),
                                rules: [rules.requiredRule]
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                            ]),
                            _: 2
                          }, 1024),
                          (items.value.contacts.length > 1)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "x-btn",
                                onClick: ($event: any) => (deleteItem(index, items.value.contacts))
                              }, _hoisted_132, 8, _hoisted_130))
                            : _createCommentVNode("", true),
                          (items.value.contacts.length > 1)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                onClick: ($event: any) => (deleteItem(index, items.value.contacts)),
                                style: {"display":"flex"},
                                class: "delete-item-btn"
                              }, _hoisted_136, 8, _hoisted_133))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128)),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        style: {"width":"100%","padding":"0 !important"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            onClick: _cache[34] || (_cache[34] = ($event: any) => (items.value.contacts.push({ ...emptyItem }))),
                            class: "add-item-btn"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_137,
                              _createTextVNode(" Add another item ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_col, { cols: "12" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "claim-item-container" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(CheckBox, {
                      onChange: validateMethod,
                      label: "Contact Fitting",
                      modelValue: variables.value.contactFitting,
                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((variables.value.contactFitting) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                (variables.value.contactFitting)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value.contactFitting, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "item-container"
                        }, [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            sm: "12",
                            md: "6",
                            lg: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(DateInput, {
                                label: "Contact Fitting Date",
                                modelValue: item.date,
                                "onUpdate:modelValue": ($event: any) => ((item.date) = $event),
                                class: "item-input"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            sm: "12",
                            md: "5",
                            lg: "5",
                            style: {"padding-bottom":"0%"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(CurrencyInput, {
                                label: "Contact Fitting Cost",
                                class: "item-input",
                                modelValue: item.amount,
                                "onUpdate:modelValue": ($event: any) => ((item.amount) = $event),
                                rules: [rules.requiredRule]
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                            ]),
                            _: 2
                          }, 1024),
                          (items.value.contactFitting.length > 1)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "x-btn",
                                onClick: ($event: any) => (deleteItem(index, items.value.contactFitting))
                              }, _hoisted_140, 8, _hoisted_138))
                            : _createCommentVNode("", true),
                          (items.value.contactFitting.length > 1)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                onClick: ($event: any) => (deleteItem(index, items.value.contactFitting)),
                                style: {"display":"flex"},
                                class: "delete-item-btn"
                              }, _hoisted_144, 8, _hoisted_141))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128)),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        style: {"width":"100%","padding":"0 !important"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            onClick: _cache[36] || (_cache[36] = ($event: any) => (items.value.contactFitting.push({ ...emptyItem }))),
                            class: "add-item-btn"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_145,
                              _createTextVNode(" Add another item ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_col, { cols: "12" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "claim-item-container" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(CheckBox, {
                      onChange: validateMethod,
                      label: "Exam",
                      modelValue: variables.value.exam,
                      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((variables.value.exam) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                (variables.value.exam)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(items.value.exam, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "item-container"
                      }, [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "12",
                          md: "6",
                          lg: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(DateInput, {
                              label: "Exam date",
                              modelValue: item.date,
                              "onUpdate:modelValue": ($event: any) => ((item.date) = $event),
                              class: "item-input",
                              rules: [rules.requiredRule]
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "12",
                          md: "5",
                          lg: "5",
                          style: {"padding-bottom":"0%"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(NumberInput, {
                              label: "Exam Cost",
                              class: "item-input",
                              modelValue: item.amount,
                              "onUpdate:modelValue": ($event: any) => ((item.amount) = $event),
                              rules: [rules.requiredRule]
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                          ]),
                          _: 2
                        }, 1024),
                        (items.value.exam.length > 1)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "x-btn",
                              onClick: ($event: any) => (deleteItem(index, items.value.exam))
                            }, _hoisted_148, 8, _hoisted_146))
                          : _createCommentVNode("", true),
                        (items.value.exam.length > 1)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              onClick: ($event: any) => (deleteItem(index, items.value.exam)),
                              style: {"display":"flex"},
                              class: "delete-item-btn"
                            }, _hoisted_152, 8, _hoisted_149))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (variables.value.exam)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  onClick: _cache[38] || (_cache[38] = ($event: any) => (items.value.exam.push({ ...emptyItem }))),
                  class: "add-item-btn"
                }, {
                  default: _withCtx(() => [
                    _hoisted_153,
                    _createTextVNode(" Add another item ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_input, {
      class: "ml-5",
      "validate-on": "lazy",
      rules: [checkBoxRules.atLeastOneCheckbox]
    }, null, 8, ["rules"])
  ], 64))
}
}

})